class BuildErrorInternalAppModel {

    constructor(code, stringTranslate) {
        this.code = code;
        this.stringTranslate = stringTranslate
    }
}

export default BuildErrorInternalAppModel